import {Button, CircularProgress, Grid, IconButton, Typography} from '@material-ui/core'
import React, {useEffect, useState} from 'react'
import WizardAdditionalFields from '../ReservationReserve/CustomComponents/WizardAdditionalFields'
import CloseIcon from '@material-ui/icons/Close'
import StepActionFields from './StepActionFields/StepActionFields'
import {StepActionContext} from '../../context/StepAction'
import {ToastMessageContext} from '../../context/ToastMessage/ToastMessage'
import Alert from '@material-ui/lab/Alert'
import Upload from './Upload'

import _ from 'lodash'
export default function NextStepActionForm({
  fields,
  action,
  setItemSelected,
  setItemUpdated,
  itemSelected,
  tabActive,
  onClose,
  onSaved = () => {},
  isReturn,
}) {
  const {
    stepActionData,
    setStepActionData,
    update,
    nextStepAction,
    updateValue,
    addReservationNextStepAction,
    clearReservationsNextStepAction,
    setFiles,
    files,
  } = React.useContext(StepActionContext)
  const ctxToast = React.useContext(ToastMessageContext)
  const onOpen = action.allow_attachment_on_open
  const onReturn = action.allow_attachment_on_return
  const [fileInputs, setFileInputs] = useState([])
  const [fileInputValues, setFileInputValues] = useState([])
  const [errMessage, setErrMessage] = useState('')
  const [name, setName] = useState([])

  const fieldName = stepActionData => {
    stepActionData?.action_fields?.map((f, index) => {
      if (
        (f.is_required === true || f.is_required_return === true) &&
        (typeof f.value === 'number'
          ? f.value === ''
          : f.type === 'MultipleListField'
          ? f.value === ''
          : f.value.trim() === '')
      ) {
        name?.push(f.name)
      }
    })
    return name
  }

  const disableApply = stepActionData => {
    let disable = ''
    let apply = false
    stepActionData?.action_fields?.map((f, index) => {
      disable =
        (f.is_required === true || f.is_required_return === true) &&
        (typeof f.value === 'number'
          ? f.value === ''
          : f.type === 'MultipleListField'
          ? f.value === ''
          : f.value.trim() === '')
      if (disable === true) {
        apply = true
      }
    })
    return apply
  }

  const handleApply = async () => {
    let apply = disableApply(stepActionData)
    if (apply) {
      let elements = fieldName(stepActionData)
      if (elements.length === 1) {
        setErrMessage(`${elements.toString()} is required.`)
      } else if (elements.length <= 5) {
        setErrMessage(`${elements.join(', ').toString()} are required.`)
      } else {
        setErrMessage(`Please fill out the required fields.`)
      }
      setName([])
    } else {
      addReservationNextStepAction()
        .then(res => {
          if (onSaved) {
            onSaved()
          }
        })
        .catch(res => {
          if (res.data === null) {
            if (res.errors.length > 0) {
              setErrMessage(res.errors.join(', '))
            } else {
              setErrMessage(`next reservation step action failed!`)
            }
          }
        })
    }
  }
  const onChange = (e, k, v) => {
    if (v) {
      updateValue(k, v)
    } else {
      updateValue(k, e.target.value)
    }
  }

  useEffect(() => {
    if (!_.isEmpty(nextStepAction.data)) {
      ctxToast.popMessage('Action was successful!')
      onClose()
      setItemUpdated(itemSelected)
      setItemSelected && setItemSelected({})
      clearReservationsNextStepAction()
    }
    return () => {}
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [nextStepAction, ctxToast, onClose, clearReservationsNextStepAction, itemSelected])
  const title = !isReturn
    ? action.name
    : action.change_return_name
    ? action.return_name
    : `Return ${action.name}`

  const handleAdd = () => {
    const values = [...fileInputs]
    values.push({value: null})
    setFileInputs(values)
  }

  return (
    <div className="c-res-mod ap-modal ap-scrollbar">
      <div className="ap-modal__header">
        <Typography
          className="ap-modal__title"
          style={{wordBreak: 'break-word', marginRight: '25px'}}
        >
          {title}
        </Typography>
        <IconButton onClick={onClose} className="ap-modal__btn-x">
          <CloseIcon />
        </IconButton>
      </div>
      <Grid
        container
        className="ap-scrollbar"
        style={{marginTop: 30, height: 375, overflowY: 'auto'}}
      >
        {stepActionData?.action_fields.length ? (
          <>
            {stepActionData?.action_fields?.map((f, index) => {
              return (
                <Grid item xs={12} style={{marginTop: 10}}>
                  <StepActionFields
                    tabActive={tabActive}
                    fieldId={f.id}
                    fieldType={f.type}
                    data={f}
                    onChange={onChange}
                    entity_id={itemSelected?.entity_id ? itemSelected?.entity_id : action.entity_id}
                    itemSelected={itemSelected}
                  />
                </Grid>
              )
            })}
            <Grid item xs={12} className="reserve-upload-btn1">
              {/* {(onOpen || onReturn) && <Upload setFiles={setFiles} files={files} />} */}
              {((!isReturn && onOpen) || (isReturn && onReturn)) && (
                <Upload
                  setFiles={setFiles}
                  files={files}
                  fileInputs={fileInputs}
                  fileInputValues={fileInputValues}
                />
              )}
            </Grid>
          </>
        ) : (
          <CircularProgress />
        )}
      </Grid>
      {((!isReturn && onOpen) || (isReturn && onReturn)) && (
        <Grid item xs={12} className="reserve-upload-btn">
          <button
            type="button"
            style={{border: 'none', backgroundColor: 'transparent', color: '#336699'}}
            onClick={() => handleAdd()}
          >
            Add new file
          </button>
        </Grid>
      )}

      <Grid
        item
        xs={12}
        style={{paddingTop: 30}}
        className="ap-modal__container ap-modal__container--right"
      >
        <div>
          {nextStepAction.isLoading && <CircularProgress size={20} style={{marginRight: 10}} />}
          {!nextStepAction.isLoading && (
            <Button
              onClick={handleApply}
              style={{width: 96}}
              className="ap-button ap-button--primary"
            >
              Apply
            </Button>
          )}
          <Button onClick={onClose} style={{width: 96}} className="ap-button ap-button--outlined">
            Cancel
          </Button>
        </div>
      </Grid>
      <div className="ap-modal__footer">
        {!_.isEmpty(errMessage) && <Alert severity="error">{errMessage}</Alert>}
      </div>
    </div>
  )
}
